import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import VerifiedIcon from "../../resources/icons/shield-tick.svg";
import NotVerifiedIcon from "../../resources/icons/shield-off.svg";
import EntityConstants from "../../configs/EntityConstants";
import { GET } from "../../service/CRUDService";
import { useTranslation } from "react-i18next";

const VpResult = () => {
  const { vp_instance_id } = useParams();
  const { t } = useTranslation();

  const [result, setResult] = useState({});

  const getVpVerificationResults = async (id) => {
    try {
      const response = await GET(
        `${EntityConstants.GET_VP_RESULT}${id}/results`
      );
      const data = await response.json();
      setResult(data);
    } catch (error) {
      console.log("error while getting category list: ", error);
    } finally {
    }
  };

  useEffect(() => {
    vp_instance_id && getVpVerificationResults(vp_instance_id);
  }, [vp_instance_id]);

  return (
    <div className="flex flex-col items-center w-full pb-3 pt-20 bg-cfSecondary min-h-screen overflow-x-hidden mt-4">
      {Object.keys(result).length > 0 && (
        <div id="vp-result-container" className="max-w-md w-full mx-auto bg-white rounded-3xl shadow-lg p-8">
          <div className="text-center mb-8">
            <div
              className={`w-20 h-20 mx-auto mb-6 rounded-full flex items-center justify-center ${
                result.verification_status == "true"
                  ? "bg-green-50"
                  : "bg-red-50"
              }`}
            >
              <img
                src={
                  result.verification_status == "true"
                    ? VerifiedIcon
                    : NotVerifiedIcon
                }
                alt=""
                className="w-10 h-10"
              />
            </div>
            <h1 id="vp-result-status-heading" className="text-2xl font-semibold mb-2">
              {t("request:verification")}{" "}
              {result.verification_status == "true"
                ? t("request:successful")
                : t("request:failed")}
            </h1>
            <p id="vp-result-message-description" className="text-gray-500">{result.message}</p>
          </div>

          <table className="w-full border-collapse">
            <tbody>
              {result?.verification_list[0]?.check && (
                <tr className="align-top">
                  <td className="text-gray-500 w-2/5 p-2 align-top">
                    {t("request:check_performed")}
                  </td>
                  <td id="vp-result-check-value" className="p-2 align-top">
                    {result?.verification_list[0]?.check}
                  </td>
                </tr>
              )}
              {result?.verification_list[0]?.vc_value && (
                <tr className="align-top">
                  <td className="text-gray-500 w-2/5 p-2 align-top">
                    {t("request:value_in_vc")}
                  </td>
                  <td id="vp-result-vc-value" className="p-2 align-top">
                    {result?.verification_list[0]?.vc_value}
                  </td>
                </tr>
              )}
              <tr className="align-top">
                <td className="text-gray-500 w-2/5 p-2 align-top">
                  {t("request:verification_time")}
                </td>
                <td id="vp-result-verification-time-value" className="p-2 align-top">{result.verification_time}</td>
              </tr>
              <tr className="align-top">
                <td className="text-gray-500 w-2/5 p-2 align-top">
                  {t("request:verification_date")}
                </td>
                <td id="vp-result-verification-date-value" className="p-2 align-top">{result.verification_date}</td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default VpResult;
